export default {
  'user-groups.title': 'Gestionar Grupos de Usuarios',
  'user-groups.action.users': 'Usuarios',
  'users-groups.title': 'Gestionar Grupos de Usuarios',
  'users-groups.userExists': 'El usuario ya pertenece a este grupo',
  'users-groups.form.selectUser': 'Selecciona un Usuario',
};
